import { ModelResource } from './resource';
import type { CreateApPortalAccountSchema } from '../models';
import { ApPortalAccount } from '../models';

export class ApPortalAccounts extends ModelResource<ApPortalAccount> {
  model = ApPortalAccount;

  resourcePath = 'v1/ap-portal-accounts';

  async createAccount(data: Partial<CreateApPortalAccountSchema>): Promise<ApPortalAccount> {
    return this.api.post(this.path(), { data }).then((response) => {
      return ApPortalAccount.fromJson(response.data);
    });
  }

  async updateAccount(apPortalAccount: ApPortalAccount, data) {
    return this.api.post(this.path(apPortalAccount.id), { data }).then((response) => {
      return apPortalAccount.updateFromJson(response.data);
    });
  }
}
